<script>
import HsSectionCard from "@/base/hs-tableview/hs-section/hs-section-card.vue";
import HsButton from "@/base/hs-button/hs-button.vue";
import HsCellSmallTitle from "@/base/hs-tableview/hs-cell-small-title/hs-cell-small-title.vue";
import HsCell1 from "@/base/hs-tableview/hs-cell-1/hs-cell-1.vue";
import HsFormCell from "@/base/hs-tableview/hs-section/hs-form-cell.vue";
import AirlineList from "@/pages/personal/passengers/card/airline-list.vue";
import HsTeleport from "@/base/hs-teleport/hs-teleport.vue";
const HOTEL_CARD_TYPE = 'HotelCard';
export default {
  props: {
    currentDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    powerDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      cardType: '',
      HOTEL_CARD_TYPE
    }
  },
  methods: {
    _add(type) {
      this.cardType = type;
      this.$refs.AirlineList && this.$refs.AirlineList.open();
    },

    // 航司列表回调
    _delegateWithSelectAirline(item, index) {
      console.log('选择了航司: ', item, index)
      if (this.cardType === HOTEL_CARD_TYPE) {
        if (this.currentDetails.HotelGroupCardList.findIndex(v => v.Code === item.Code) >= 0) {
          this.$toast(this.$t('MnlyOneMembershipCardCanBeAddedToTheSameHotel'))
          return
        }
        this.currentDetails.HotelGroupCardList.push({
          Code: item.Code,
          Name: item.Name,
          Name_EN: item.Name_EN,
          LogoName: item.LogoName,
          LogoUrl: item.LogoUrl,
          CardNo: '',
        })
      } else {
        if (this.currentDetails.TravelCardList.findIndex(v => v.AirLineCode === item.AirLineCode) >= 0) {
          this.$toast(this.$t('OneAirlineCanOnlyAddOneFrequentTravelCard'))
          return
        }
        this.currentDetails.TravelCardList.push({
          AirLineCode: item.AirLineCode,
          AirLineName: item.AirLineName,
          AirLineLogoUrl: item.AirLineLogoUrl,
          CardNo: '',
        })
      }
      this.$emit('update:currentDetails', this.currentDetails)
    },

    /** 删除卡 */
    _deleteCard(type, index) {
      this.$alert({
        type: 'new',
        content: this.$t('AreYouSureToDelete'),
        cancelTxt: this.$t('Cancel'),
        confirmTxt: this.$t('Confirm'),
        confirmFn: () => {
          if (type === HOTEL_CARD_TYPE) {
            this.currentDetails.HotelGroupCardList.splice(index, 1)
          } else {
            this.currentDetails.TravelCardList.splice(index, 1)
          }
          this.$emit('update:currentDetails', this.currentDetails)
        }
      })
    }
  },
  components: {
    AirlineList,
    HsFormCell,
    HsCell1,
    HsCellSmallTitle,
    HsButton,
    HsSectionCard,
    HsTeleport,
  },
}
</script>

<template>
  <div style="width: 100%">
    <hs-section-card :title="$t('FrequentTravelerCardInformation')" v-if="powerDetails.showCard">
      <div class="details">
        <div v-for="(item, index) in (currentDetails.TravelCardList || [])" :key="index">
          <hs-cell-1 :showLogo="false" :show-separator="false">
            <div class="title">
              <span class="credential-name">{{ item.AirLineName }}</span>
              <span class="del" @click="_deleteCard('', index)"></span>
            </div>
          </hs-cell-1>
          <hs-form-cell
              v-model="item.CardNo"
              :title="$t('CardNumber')"
              type="input"
              :placeholder="$getPlaceholder(0,false)"
              clearable
          />
        </div>

        <div class="add">
          <hs-button class="btn" font-size="14px" height="44px" @click.native="_add('')"><span></span>{{$t('NewFrequentTravelCard_1')}}</hs-button>
        </div>
      </div>
    </hs-section-card>
    <hs-section-card :title="$t('HotelGroupMembershipCard_1')" v-if="powerDetails.showHotelCard">
      <div class="details">
        <div v-for="(item, index) in (currentDetails.HotelGroupCardList || [])" :key="index">
          <hs-cell-1 :showLogo="false" :show-separator="false">
            <div class="title">
              <span class="credential-name">{{ item.Name }}</span>
              <span class="del" @click="_deleteCard(HOTEL_CARD_TYPE, index)"></span>
            </div>
          </hs-cell-1>
          <hs-form-cell
              v-model="item.CardNo"
              :title="$t('CardNumber')"
              type="input"
              :placeholder="$getPlaceholder(0,false)"
              clearable
          />
        </div>

        <div class="add">
          <hs-button class="btn" font-size="14px" height="44px" @click.native="_add(HOTEL_CARD_TYPE)">
            <span></span>{{$t('NewHotelGroupMembershipCard')}}
          </hs-button>
        </div>
      </div>
    </hs-section-card>

    <hs-teleport to="body">
      <airline-list ref="AirlineList" :type="cardType" @select="_delegateWithSelectAirline"></airline-list>
    </hs-teleport>
  </div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.details{
  .title {
    @extends .flex-between;
    padding: 10px 0;
    width: 100%;
    min-height: 56px;

    > .credential-name {
      @extends .flex-start;
      @extends .hs-font-subtitle-middle;
    }

    > .del {
      width: 30px;
      height: 30px;
      background: url(@/assets/image/base/cell/icons_16pt_trash.png) center center no-repeat;
      background-size: 16px 16px;
    }
  }
  // 添加证件信息
  >.add{
    padding: 8px 12px;
    margin-bottom: 8px;
    >.btn{
      background-color: $color_black_20;
      border-radius: 6px;
      color: $color_theme_300;
      font-weight: 500;
      min-height: 44px;
      >span{
        display: inline-flex;
        width: 16px;
        height: 16px;
        margin-right: 2px;
        line-height: 16px;
        background-image: url('@/assets/image/base/add/icons_16pt_add.png');
        background-size: 100% 100%;
      }
    }
  }
}
</style>
